// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 详情 GET /system/suppress_word/${param0} */
export async function getSystemSuppressWordId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getSystemSuppressWordIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.SuppressWord>(`/system/suppress_word/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 修改 POST /system/suppress_word/${param0} */
export async function postSystemSuppressWordId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postSystemSuppressWordIdParams,
  body: string,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.SuppressWord>(`/system/suppress_word/${param0}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 添加 POST /system/suppress_word/add */
export async function postSystemSuppressWordAdd(body: string, options?: { [key: string]: any }) {
  return request<API.SuppressWord>('/system/suppress_word/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除 POST /system/suppress_word/delete */
export async function postSystemSuppressWordOpenApiDelete(
  body: API.LongIdsRequest,
  options?: { [key: string]: any },
) {
  return request<number>('/system/suppress_word/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 列表 GET /system/suppress_word/list */
export async function getSystemSuppressWordList(options?: { [key: string]: any }) {
  return request<API.SPageC2ABSuppressWordC2BB>('/system/suppress_word/list', {
    method: 'GET',
    ...(options || {}),
  });
}
